// Converts relative /api/uploads/... paths to absolute URLs.
// In static mode all images are already absolute https:// URLs so this is a passthrough.
export function resolveImageUrl(url) {
  if (!url) return "";
  if (url.startsWith("http://") || url.startsWith("https://")) return url;
  const backendUrl = process.env.REACT_APP_BACKEND_URL || "";
  if (url.startsWith("/")) return `${backendUrl}${url}`;
  return url;
}
